export const variantTypes = {
  text: 'text',
  action: 'action',
  icon: 'icon',
  countable: 'countable',
  textWithIcon: 'textWithIcon',
};
